import React from 'react';
import ImportBookState from "./../states/ImportBookState";
const StripeListingContext = React.createContext();
const StripeListingProvider = ({children})=>{
	const state = ImportBookState();
	return (<StripeListingContext.Provider value={{...state}}>{children}</StripeListingContext.Provider>);
}
export {StripeListingProvider, StripeListingContext}; 